import { __extends } from "tslib";
import { InputText } from '@victorequena22/component-bootstrap';
import { Col, Card, Row, Button, InputGroup, Accordion } from 'react-bootstrap';
import React from 'react';
import CardBuscador from './Card';
var CardBuscadorAvanzado = /** @class */ (function (_super) {
    __extends(CardBuscadorAvanzado, _super);
    function CardBuscadorAvanzado(p) {
        var _this = _super.call(this, p) || this;
        _this.permiso = '';
        _this.Avansado = _this.Avansado.bind(_this);
        return _this;
    }
    CardBuscadorAvanzado.prototype.Avansado = function () {
        return React.createElement(React.Fragment, null);
    };
    CardBuscadorAvanzado.prototype.render = function () {
        var _a = this, Body = _a.Body, Buscador = _a.Buscador, Avansado = _a.Avansado, Title = _a.Title;
        return (React.createElement(Card, { as: Accordion },
            React.createElement(Card.Header, { className: 'bg-info d-flex' },
                React.createElement(Title, null)),
            React.createElement(Card.Body, null,
                React.createElement(Buscador, null),
                React.createElement(Accordion.Collapse, { eventKey: '0' },
                    React.createElement(Card, null,
                        React.createElement(Card.Body, null,
                            React.createElement(Avansado, null)))),
                React.createElement(Col, { md: 12 },
                    React.createElement(Body, null)))));
    };
    CardBuscadorAvanzado.prototype.Buscador = function () {
        var _this = this;
        return (React.createElement(Row, { className: 'd-flex', style: { paddingBottom: '15px' } },
            React.createElement(Col, { md: 9, className: 'mr-auto' },
                React.createElement(InputGroup, null,
                    React.createElement(InputGroup.Prepend, null,
                        React.createElement(InputGroup.Text, null, this.buscarLabel)),
                    React.createElement(InputText, { upper: true, setData: this.setState, update: 'buscar', value: this.state.buscar }),
                    React.createElement(InputGroup.Append, null,
                        React.createElement(Button, { variant: 'primary' },
                            React.createElement("i", { className: 'fa fa-search' }),
                            " BUSCAR"),
                        React.createElement(Button, { as: Accordion.Toggle, eventKey: '0', variant: 'default', "data-tip": 'BUSQUEDA DETALLADA', onClick: function () {
                                _this.setState({ open: !_this.state.open });
                            } },
                            React.createElement("i", { className: 'fa fa-wrench' }),
                            " DETALLADO"))))));
    };
    return CardBuscadorAvanzado;
}(CardBuscador));
export default CardBuscadorAvanzado;
//# sourceMappingURL=Avanzado.js.map